import React from 'react';
import axios from "../../containers/api";
import {    showCatchError,   toCurrency  } from "../../helpers/Utils";
import { Button,   Input,   Alert,   FormGroup, Label  } from "reactstrap";
 
class OnlineCharge extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
           
            Amount:null,
            errors: [],
            
        };
        //refs
        console.log(this.props.location);
        //states
         
    }

    componentDidMount() {
         
    }

    //SetState = async () => {
    //    await this.setState({
    //        isPay: false,
    //    })
    //}
    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.Amount < 10000 || this.state.Amount === null) {
            error.push("مقدار اعتبار وارد شده نباید کمتر از 10000 دیال باشد.");
        }
       

        this.setState({ errors: error });
        if (error.length === 0) {

             this.Pay();
           // this.VerifySalePaymenttest();
           // this.redirecttest();
             

        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    VerifySalePaymenttest = () => {
        let model = {
            Amount: this.state.Amount
        };
        this.setState({
            luckButton: true
        });
        this.props.showSpinner();
         
         axios.post('/api/v1/SalePayment/VerifySalePaymenttest')
       
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data !== null) {
                    if (res.status === 200) {

                        
                        this.setState({
                            luckButton: false
                        });
                        this.props.showAlert(res.data.data.message, "success");
                    }
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
                this.setState({
                    luckButton: false
                });
            });
    };
    redirecttest = () => {
        this.props.showSpinner();
        axios.post('api/v1/ShowMessage/ShowView')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ LoadHalls: res.data.data });

            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    Pay = () => {
        let model = {
            Amount: this.state.Amount
        };
        this.setState({
            luckButton: true
        });
        this.props.showSpinner();
        axios.post('/api/v1/SalePayment/AddSalePayment', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data !== null) {
                    if (res.status === 200) {
                        if (res.data.data.data !== null) { 
                        window.location.href = "https://pec.shaparak.ir/NewIPG/?Token=" + res.data.data.data;
                    }
                        this.setState({
                            luckButton: false
                        });
                        //this.props.showAlert(res.data.data.message, "success");
                    }
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
                this.setState({
                    luckButton: false
                });
            });
    };
    VerifySalePayment = () => {
      
        this.setState({
            luckButton: true
        });
        this.props.showSpinner();
        axios.post('/api/v1/SalePayment/VerifySalePayment' )
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data !== null) {
                    if (res.status === 200) {

                      
                        this.setState({
                            luckButton: false
                        });
                        this.props.showAlert(res.data.data.message, "success");
                    }
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
                this.setState({
                    luckButton: false
                });
            });
    };
    render() {
        return (
            <div id="preBuyPackage" style={this.props.style}>
                <div className="PreBuyPackage">


                    {this.state.errors.length === 0 ?
                        null
                        :
                        <div>
                            {(this.state.errors.map((error, i) => {
                                return (
                                    <Alert color="danger" key={i}>{error}</Alert>
                                )
                            }))}
                        </div>
                    }


                      <div>
                        <div className="package">

                            <FormGroup className="w-md-20 w-100 px-1">
                                <Label>مبلغ</Label>
                                <Input value={toCurrency(this.state.Amount)}
                                    onChange={(e) => this.setState({ Amount: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                            </FormGroup>
                          
                            <Button className="mx-3 my-md-0 my-1" color="primary"
                                onClick={() => this.props.showSweetAlert("آیا از افزایش اعتبار  مطمئن هستید؟", "", "warning", this.validateInputData)}>
                                پرداخت
                            </Button>
                          
                        </div>

                        

                    </div> 

                     
                </div>
            </div>
        );
    }
}

export default OnlineCharge;